import React from 'react';

export function ContentPasteIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M38 4h-8.36C28.8 1.68 26.6 0 24 0c-2.6 0-4.8 1.68-5.64 4H10C7.8 4 6 5.8 6 8v32c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4zM24 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm14 36H10V8h4v6h20V8h4v32z" />
    </svg>
  );
}
